import gql from 'graphql-tag';

export const listItemMasterSearchCustom = /* GraphQL */ `
  query ListItemMasterSearch($word: String!, $type: String!, $rowfrom: Int!, $limitno: Int!) {
    listItemMasterSearch(word: $word, type: $type, rowfrom: $rowfrom, limitno: $limitno) {
      itemid
      itemcode
      companyid
      itemname
      measurementcd
      itemtype
    }
  }
`;

export const listPurchaseMasterRangeCustom = /* GraphQL */ `
  query ListPurchaseMasterRange($startdate: Int!, $enddate: Int!) {
    listPurchaseMasterRange(startdate: $startdate, enddate: $enddate) {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      purchasegsttypecd
      supplierid
      entrydate
      vouchernumber
      supplierinvoicedate
      supplierinvoicenumber
      supplieraddressid
      paymenttypecd
      paidamount
      creditduration
      paymentaccountid
      comments
      tdsapplicableflag
      granttotalamount
      balancedueamount
      paymentclearedflag
      placeofsupply
      companystate
      relatedpurchasetdsdetails {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tdsapplicablecd
        totaltaxableamount
        ineligibletcflag
        reversechargeflag
        gstcesstotal
        tdsamount
        adjustmentamount
        tdssection
        tdspercentage
        tdsmanual
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpurchasetcsdetails {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tcsapplicablecd
        totaltaxableamount
        ineligibletcflag
        reversechargeflag
        gstcesstotal
        tcsamount
        adjustmentamount
        tcssection
        lastupdatedby
        statuscode
        statusmessage
        tcspercentage
        tcsmanual
        __typename
      }
      relatedpurchaselineitems {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        itemnumber
        itemid
        purchaseaccountid
        hsncode
        itemquantity
        unittypecd
        itemrate
        itemamount
        itemdiscount
        netamount
        relatedpurchaselinegst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        relateditemmaster {
          itemid
          itemcode
          companyid
          enteredtimestamp
          expiredtimestamp
          itemname
          salesinvoiceflag
          purchaseinvoiceflag
          itemcategorycd
          measurementcd
          currencycd
          salesaccountid
          purchaseaccountid
          taxabilitycd
          reversechargeflag
          itemtype
          hsnid
          is_active
          statuscode
          statusmessage
          relateditemamountdetails {
            id
            itemid
            companyid
            companybranchid
            enteredtimestamp
            expiredtimestamp
            amount
            effectivedate
            expireddate
            hsnid
            gstcompensationtype
            gstcompensationvalue
            gstrate
            statuscode
            statusmessage
            lastupdatedby
            discounttype
            discountvalue
            invoicetype
            pricetype
            isactive
            isdefault
            __typename
          }
          relateditemgstdetails {
            itemid
            companyid
            enteredtimestamp
            expiredtimestamp
            hsnid
            gstcesstype
            gstcompensationvalue
            effectivedate
            expireddate
            gstcessvalue
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }

          lastupdatedby
          serialnumber
          financialyearid
          description
          hsnsacid
          hsncodetype
          hsncodevalue
          hsndescription
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        taxability
        pricetype
        lotid
        hsnid
        hsncodetype
        hnsndescription
        gstrate
        gstamount
        cessamount
        unit
        uqc
        purchaseaccountname
        itemname
        itemcode
        itemtype
        manualdiscount
        manualcess
        __typename
      }
      relatedpurchaselinenonitems {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        purchaselineitemtype
        purchaseaccountid
        hsnsaccode
        itemdescription
        taxableamount
        netamount
        relatedpurchaselinenongst {
          purchaseid
          purchaseitemid
          companyid
          companybranchid
          enteredtimestamp
          expiredtimestamp
          gstrate
          cessamount
          gstamount
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        statuscode
        statusmessage
        taxability
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gstamount
        cessamount
        purchaseaccountname
        __typename
      }
      relatedpurchaselinegst {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        cessamount
        gstamount
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpurchaselinenongst {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        gstrate
        cessamount
        gstamount
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }

      relatedpartymaster {
        partyid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        partytypecd
        partydisplayname
        partylegalname
        groupaccountid
        gstcategory
        placeofsupply
        entity
        email
        contactnumber
        whatsappnumber
        accountsid
        is_active
        msmetype
        deliveryconsigneename
        deliveryconsigneegstin
        statuscode
        statusmessage
        relatedpartygstdetails {
          partyid
          enteredtimestamp
          expiredtimestamp
          pannumber
          gstin
          partyaddressid
          lastupdatedby
          statuscode
          statusmessage
          __typename
        }
        lastupdatedby
        tdspercentage
        udhyamregno
        sameaddressflag
        comments
        tdssection
        __typename
      }
      lastupdatedby
      cancelflag
      roundoffamount
      discounttype
      discountvalue
      adjustmentamount
      statuscode
      statusmessage
      serialnumber
      currencycode
      currencyrate
      partydisplayname
      partylegalname
      partyaccountid
      reversechargeflag
      overduedays
      paymentstatus
      partyregistrationtype
      purchaseinvoicepdf
      __typename
    }
  }
`;

export const listUserCompaniesCustom = /* GraphQL */ `
  query ListUserCompanies {
    listUserCompanies {
      companyid
      enteredtimestamp
      expiredtimestamp
      companylegalname
      companyshort
      companylogourl
      lastupdatedby
      statuscode
      statusmessage
      activeflag
      companydeletiontime
      relatedfinancialyeardata {
        financialyearid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        startdate
        enddate
        startyear
        endyear
        comments
        userid
        aliasname
        statuscode
        statusmessage
        freezestatus
        transferdate
        freezedate
        stepscompleted
        __typename
      }
      financialyearid
      lastupdatedtimestamp
      __typename
    }
  }
`;

export const getPartyMasterCustom = /* GraphQL */ `
  query GetPartyMaster($partyid: Int!) {
    getPartyMaster(partyid: $partyid) {
      partyid
      partydisplayname
      partylegalname
      groupaccountid
      gstcategory
      accountsid
      is_active
      statuscode
      statusmessage
    }
  }
`;

export const CustomListAccountMasterSearch = /* GraphQL */ `
  query ListAccountMasterSearch($word: String!) {
    listAccountMasterSearch(word: $word) {
      accountsid
      companyid
      companybranchid
      accountname
      accounttypecd
      accountgroupid
      statuscode
      statusmessage
      restrictedflag
      is_active
      accountgroupname
      __typename
    }
  }
`;

export const getCutomPartyMaster = /* GraphQL */ `
  query GetPartyMaster($partyid: Int!) {
    getPartyMaster(partyid: $partyid) {
      partyid
      email
      partydisplayname
      accountsid
      partylegalname
      enteredtimestamp
      partytypecd
      groupaccountid
      comments
      contactnumber
      deliveryconsigneegstin
      deliveryconsigneename
      entity
      gstcategory
      placeofsupply
      is_active
      msmetype
      whatsappnumber
      sameaddressflag
      tdspercentage
      tdssection
      udhyamregno
    }
  }
`;

export const listAccountMasterFlatCustom = /* GraphQL */ `
  query ListAccountMaster {
    listAccountMaster {
      companyid
      accountsid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      __typename
    }
  }
`;

export const getTransactionMasterCustom = /* GraphQL */ `
  query GetTransactionMaster($transactionid: Int!) {
    getTransactionMaster(transactionid: $transactionid) {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      vouchernumber
      entrydate
      bankreferencenumber
      comments
      relatedtransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        accountid
        creditamount
        debitamount
        comments
        entryordernumber
        transactionbalance
        openingbalance
      }
    }
  }
`;

export const listPartyAndTransactionMastersCustomPyt = /* GraphQL */ `
  query ListPartyAndTransactionMasters {
    listPartymasters: listPartymasters {
      partyid
      companyid
      enteredtimestamp
      expiredtimestamp
      partytypecd
      partydisplayname
      groupaccountid
      gstcategory
      contactnumber
      whatsappnumber
      accountsid
      is_active
      msmetype
      deliveryconsigneename
      deliveryconsigneegstin
      statuscode
      statusmessage
    }
    listTransactionMaster: listTransactionMaster {
      transactionid
      companyid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      vouchernumber
      entrydate
      bankreferencenumber
    }
  }
`;

export const listAccountMasterv2Custom = /* GraphQL */ `
  query ListAccountMasterv2 {
    listAccountMasterv2 {
      accountsid
      companyid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accountgroupenteredtimestamp
      accountgroupexpiredtimestamp
      accountgrouptypecd
      accountgroupname
      accountparentgroupid
      accountgroupdisplayordernumber
      accountgrouprestrictedflag
      accountgroupis_active
      accountgstenteredtimestamp
      accountgstexpiredtimestamp
      accountgsteffectivedate
      accountgstexpireddate
      hsnid
      gstcompensationtype
      gstrate
      cessamount
      accounttypeflag
      partyid
      tdspercentage
      tdssection
      companybranchid
      path
      tax_type
      __typename
    }
  }
`;

export const listPartyCustom = gql`
  query ListPartyCustom($rowfrom: Int!, $limitno: Int!, $columnname: String, $ordertype: String, $searchmode: Int, $searcharray: AWSJSON) {
    listPartymastersv2(
      rowfrom: $rowfrom
      limitno: $limitno
      columnname: $columnname
      ordertype: $ordertype
      searchmode: $searchmode
      searcharray: $searcharray
    ) {
      partyid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      partytypecd
      partydisplayname
      partylegalname
      groupaccountid
      gstcategory
      placeofsupply
      entity
      email
      contactnumber
      whatsappnumber
      accountsid
      is_active
      msmetype
      deliveryconsigneename
      deliveryconsigneegstin
      statuscode
      statusmessage
      lastupdatedby
      tdspercentage
      udhyamregno
      partygstenteredtimestamp
      partygstexpiredtimestamp
      pannummber
      gstin
      partyaddressid
      contacttypename
      contactdesignationname
      contactorder
      partycontactemail
      phonenumber
      partycontactwhatsappnumber
      creditperiodduration
      billingcurrency
      creditlimitcd
      creditlimitamount
      billwiseflag
      notes
      sameaddressflag
      comments
      accountbalance
      tdssection
      __typename
    }
    listPartymastersv2Count(columnname: $columnname, ordertype: $ordertype, searchmode: $searchmode, searcharray: $searcharray) {
      partycount
      statuscode
      statusmessage
      __typename
    }
  }
`;
export const listInvoiceCustom = gql`
  query listInvoiceCustom(
    $rowfrom: Int!
    $columnname: String
    $ordertype: String
    $searchmode: Int
    $searcharray: AWSJSON
    $limitno: Int!
  ) {
    listInvoiceMasterv2(
      limitno: $limitno
      columnname: $columnname
      ordertype: $ordertype
      searchmode: $searchmode
      searcharray: $searcharray
      rowfrom: $rowfrom
    ) {
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      invoicetypecd
      partyid
      paymentaccountid
      invoicedate
      invoicenumber
      customerordernumber
      customerorderdate
      invoiceamount
      paymenttype
      creditduration
      invoicebillingaddressid
      invoicedeliveryaddressid
      invoicetaxabletypecd
      receipturl
      invoicelinetypecd
      invoicecurrencycd
      exchangerate
      comments
      receivedamount
      adjustmentamount
      placeofsupply
      balancedueamount
      reversechargeflag
      tcsapplicableflag
      lastupdatedby
      statuscode
      statusmessage
      cancelflag
      consigneename
      consigneegstin
      companystate
      cancelremark
      deleteremark
      roundoffamount
      discounttype
      discountvalue
      serialnumber
      currencycode
      currencyrate
      partydisplayname
      partylegalname
      partyaccountid
      paymentstatus
      ackno
      ackdt
      irn
      signedqrcode
      partyemail
      is_cancelled
      cancel_reason
      cancel_remarks
      invoiceid
      __typename
    }
    listInvoiceMasterCount(ordertype: $ordertype, searchmode: $searchmode, searcharray: $searcharray, columnname: $columnname) {
      invoicemasterlistcount
      statusmessage
      __typename
      statuscode
    }
  }
`;

export const listPurchaseInvoiceCustom = gql`
  query listPurchaseInvoiceCustom(
    $limitno: Int!
    $columnname: String
    $ordertype: String
    $searchmode: Int
    $searcharray: AWSJSON
    $rowfrom: Int!
  ) {
    listPurchaseMasterTest(
      limitno: $limitno
      columnname: $columnname
      ordertype: $ordertype
      searchmode: $searchmode
      searcharray: $searcharray
      rowfrom: $rowfrom
    ) {
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      purchasegsttypecd
      supplierid
      entrydate
      vouchernumber
      supplierinvoicedate
      supplierinvoicenumber
      supplieraddressid
      paymenttypecd
      paidamount
      creditduration
      paymentaccountid
      comments
      tdsapplicableflag
      granttotalamount
      balancedueamount
      paymentclearedflag
      placeofsupply
      companystate
      lastupdatedby
      cancelflag
      roundoffamount
      discounttype
      discountvalue
      adjustmentamount
      statuscode
      statusmessage
      serialnumber
      currencycode
      currencyrate
      partydisplayname
      partylegalname
      partyaccountid
      reversechargeflag
      overduedays
      paymentstatus
      partyregistrationtype
      __typename
      purchaseid
    }
    listPurchaseMasterCount(ordertype: $ordertype, searchmode: $searchmode, searcharray: $searcharray, columnname: $columnname) {
      purchasemasterlistcount
      statusmessage
      __typename
      statuscode
    }
  }
`;
// export const listCrDrInvoiceCustom = gql`

// `
export const listTransactionMasterv2Custom = /* GraphQL */ `
  query listTransactionMasterv2Custom(
    $transactiontypecd: String
    $rowfrom: Int!
    $limitno: Int!
    $columnname: String
    $ordertype: String
    $searchmode: Int
    $searcharray: AWSJSON
  ) {
    listTransactionMasterv2(
      transactiontypecd: $transactiontypecd
      rowfrom: $rowfrom
      limitno: $limitno
      columnname: $columnname
      ordertype: $ordertype
      searchmode: $searchmode
      searcharray: $searcharray
    ) {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      vouchernumber
      entrydate
      bankreferencenumber
      comments
      lastupdatedby
      statuscode
      statusmessage
      cancelflag
      cancelremark
      serialnumber
      paidfrom
      paidto
      paidfromamount
      paidtoamount
      paidfromaccountid
      paidtoaccountid
      paidfromemail
      paidtoemail
      paidfrompartyid
      paidtopartyid
      paidfrompartytypecd
      paidtopartytypecd
      __typename
    }
    listTransactionMasterCount(
      transactiontypecd: $transactiontypecd
      columnname: $columnname
      ordertype: $ordertype
      searchmode: $searchmode
      searcharray: $searcharray
    ) {
      transactionmasterlistcount
      statuscode
      statusmessage
      __typename
    }
  }
`;
export const listItemMasterCustom = /* GraphQL */ `
  query listItemMasterCustom(
    $rowfrom: Int!
    $limitno: Int!
    $columnname: String
    $ordertype: String
    $searchmode: Int
    $searcharray: AWSJSON
  ) {
    listItemmastersv2Count(
      rowfrom: $rowfrom
      limitno: $limitno
      columnname: $columnname
      ordertype: $ordertype
      searchmode: $searchmode
      searcharray: $searcharray
    ) {
      itemcount
      statuscode
      statusmessage
      __typename
    }
    listItemmastersv2(
      rowfrom: $rowfrom
      limitno: $limitno
      columnname: $columnname
      ordertype: $ordertype
      searchmode: $searchmode
      searcharray: $searcharray
    ) {
      itemid
      itemcode
      companyid
      enteredtimestamp
      expiredtimestamp
      itemname
      salesinvoiceflag
      purchaseinvoiceflag
      itemcategorycd
      measurementcd
      currencycd
      salesaccountid
      purchaseaccountid
      taxabilitycd
      reversechargeflag
      itemtype
      hsnid
      is_active
      statuscode
      statusmessage
      lastupdatedby
      itemamountenteredtimestamp
      itemamountexpiredtimestamp
      amount
      effectivedate
      expireddate
      itemamounthsnid
      gstcompensationtype
      gstcompensationvalue
      gstrate
      discounttype
      discountvalue
      imagename
      imageurl
      serialnumber
      isdefault
      invoicetype
      defaultsellingprice
      defaultpurchaseprice
      codetext
      itemcategory
      sellinggstcompensationtype
      purchasegstcompensationtype
      sellinggstcompensationvalue
      purchasegstcompensationvalue
      sellinggstrate
      purchasegstrate
      sellingdiscounttype
      purchasediscounttype
      sellingdiscountvalue
      purchasediscountvalue
      __typename
    }
  }
`;

export const listInvoiceMasterv2Custom = /* GraphQL */ `
  query ListInvoiceMasterv2(
    $rowfrom: Int!
    $limitno: Int!
    $columnname: String
    $ordertype: String
    $searchmode: Int
    $searcharray: AWSJSON
  ) {
    listInvoiceMasterv2(
      rowfrom: $rowfrom
      limitno: $limitno
      columnname: $columnname
      ordertype: $ordertype
      searchmode: $searchmode
      searcharray: $searcharray
    ) {
      invoiceid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      invoicetypecd
      partyid
      paymentaccountid
      invoicedate
      invoicenumber
      customerordernumber
      customerorderdate
      invoiceamount
      paymenttype
      creditduration
      invoicebillingaddressid
      invoicedeliveryaddressid
      invoicetaxabletypecd
      receipturl
      invoicelinetypecd
      invoicecurrencycd
      exchangerate
      comments
      receivedamount
      adjustmentamount
      placeofsupply
      balancedueamount
      ewaybillpdf
      reversechargeflag
      tcsapplicableflag
      lastupdatedby
      statuscode
      statusmessage
      cancelflag
      consigneename
      consigneegstin
      companystate
      cancelremark
      deleteremark
      roundoffamount
      discounttype
      discountvalue
      serialnumber
      currencycode
      currencyrate
      partydisplayname
      partylegalname
      partygstcategory
      partyaccountid
      paymentstatus
      ackno
      ackdt
      irn
      goods_exist
      signedqrcode
      partyemail
      invoicepdf
      partygstin
      is_cancelled
      cancel_reason
      cancel_remarks
      ewaybillno
      validupto
      ewaybill_is_cancelled
      ewaybill_cancel_remarks
      cancel_rsn_code
      einvoiceenteredtimestamp
      ewaybillenteredtimestamp
      partytypecd
      phonenumber
      ewaybillstatus
      overduedays
      __typename
    }
  }
`;
export const getCompanyV2 = gql`
  query ListCompanyDocuments($DocumentType: String!, $PartyID: Int!, $StartDate: Int!, $EndDate: Int!) {
    documents: listCompanyDocuments(documenttype: $DocumentType, partyid: $PartyID) {
      id
      companyid
      partyid
      documenttype
      enteredtimestamp
      expiredtimestamp
      imagename
      imageurl
      lastupdatedby
      isactive
      type
      documentname
      __typename
    }

    count: listDayBookTransactionsCount(startdate: $StartDate, enddate: $EndDate) {
      transactioncount
      __typename
    }
    lut: listLUTBondMaster {
      id
      lutno
      companyid
      enteredtimestamp
      expiredtimestamp
      validfrom
      validto
      financialyearid
      __typename
    }
  }
`;
export const listGeneralSettingV2 = /* GraphQL */ `
  query ListGeneralSetting(
    $EntryTypeCD1: String!
    $EntryTypeCD2: String!
    $EntryTypeCD3: String!
    $EntryTypeCD4: String!
    $EntryTypeCD5: String!
    $EntryTypeCD6: String!
    $EntryTypeCD7: String!
    $EntryTypeCD8: String!
    $EntryTypeCD9: String!
    $EntryTypeCD10: String!
    $FinancialYearID: Int
  ) {
    goods: listGeneralSetting(entrytypecd: $EntryTypeCD1, financialyearid: $FinancialYearID) {
      id
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      financialyearid
      entrytypecd
      serialnumber
      serialisactive
      serialisused
      serialflag
      taxability
      startinvoicenumber
      nextinvoicenumber
      prefix
      suffix
      restrictedflag
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    service: listGeneralSetting(entrytypecd: $EntryTypeCD2, financialyearid: $FinancialYearID) {
      id
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      taxability
      financialyearid
      entrytypecd
      restrictedflag
      serialnumber
      serialisactive
      serialisused
      serialflag
      startinvoicenumber
      nextinvoicenumber
      prefix
      suffix
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    sales: listGeneralSetting(entrytypecd: $EntryTypeCD3, financialyearid: $FinancialYearID) {
      id
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      taxability
      restrictedflag
      financialyearid
      entrytypecd
      serialnumber
      serialisactive
      serialisused
      serialflag
      startinvoicenumber
      nextinvoicenumber
      prefix
      suffix
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    purchase: listGeneralSetting(entrytypecd: $EntryTypeCD4, financialyearid: $FinancialYearID) {
      id
      companyid
      companybranchid
      enteredtimestamp
      taxability
      restrictedflag
      expiredtimestamp
      financialyearid
      entrytypecd
      serialnumber
      serialisactive
      serialisused
      serialflag
      startinvoicenumber
      nextinvoicenumber
      prefix
      suffix
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    pos: listGeneralSetting(entrytypecd: $EntryTypeCD5, financialyearid: $FinancialYearID) {
      id
      companyid
      companybranchid
      taxability
      enteredtimestamp
      restrictedflag
      expiredtimestamp
      financialyearid
      entrytypecd
      serialnumber
      serialisactive
      serialisused
      serialflag
      startinvoicenumber
      nextinvoicenumber
      prefix
      suffix
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    journal: listGeneralSetting(entrytypecd: $EntryTypeCD6, financialyearid: $FinancialYearID) {
      id
      companyid
      companybranchid
      enteredtimestamp
      restrictedflag
      taxability
      expiredtimestamp
      financialyearid
      entrytypecd
      serialnumber
      serialisactive
      serialisused
      serialflag
      startinvoicenumber
      nextinvoicenumber
      prefix
      suffix
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    payment: listGeneralSetting(entrytypecd: $EntryTypeCD7, financialyearid: $FinancialYearID) {
      id
      companyid
      companybranchid
      restrictedflag
      taxability
      enteredtimestamp
      expiredtimestamp
      financialyearid
      entrytypecd
      serialnumber
      serialisactive
      serialisused
      serialflag
      startinvoicenumber
      nextinvoicenumber
      prefix
      suffix
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    receipt: listGeneralSetting(entrytypecd: $EntryTypeCD8, financialyearid: $FinancialYearID) {
      id
      companyid
      companybranchid
      taxability
      restrictedflag
      enteredtimestamp
      expiredtimestamp
      financialyearid
      entrytypecd
      serialnumber
      serialisactive
      serialisused
      serialflag
      startinvoicenumber
      nextinvoicenumber
      prefix
      suffix
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    credit: listGeneralSetting(entrytypecd: $EntryTypeCD9, financialyearid: $FinancialYearID) {
      id
      companyid
      companybranchid
      restrictedflag
      enteredtimestamp
      expiredtimestamp
      taxability
      financialyearid
      entrytypecd
      serialnumber
      serialisactive
      serialisused
      serialflag
      startinvoicenumber
      nextinvoicenumber
      prefix
      suffix
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
    debit: listGeneralSetting(entrytypecd: $EntryTypeCD10, financialyearid: $FinancialYearID) {
      id
      companyid
      companybranchid
      restrictedflag
      enteredtimestamp
      taxability
      expiredtimestamp
      financialyearid
      entrytypecd
      serialnumber
      serialisactive
      serialisused
      serialflag
      startinvoicenumber
      nextinvoicenumber
      prefix
      suffix
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
  }
`;
export const getPartyAccountData = gql`
  query GetPartyDetails($accountgroupid: Int!, $accountgroupsubid: Int!, $objecttype1: String!) {
    accountGroup: getAccountGroupMaster(accountgroupid: $accountgroupid) {
      accountgroupid
      companyid
      companybranchid
      accountgroupname
      accountparentgroupid
    }
    subGroup: listaccountsubgroups(accountgroupid: $accountgroupsubid) {
      accountgroupid
      companyid
      companybranchid
      accountgroupname
      accountparentgroupid
    }
    tds: getCompanyCodeTranslation(codetype: $objecttype1) {
      id
      companyid
      codetype
      codevalue
      codetext
      codeorder
      uqc
      is_active
    }
  }
`;
export const getAccountGroupMasterCustom = /* GraphQL */ `
  query GetAccountGroupMaster($accountgroupid: Int!) {
    getAccountGroupMaster(accountgroupid: $accountgroupid) {
      accountgroupid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accounttypecd
      accountgroupname
      accountparentgroupid
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      __typename
    }
  }
`;
export const getPartyAccountData1 = gql`
  query GetPartyDetails($accountgroupid: Int!, $accountgroupsubid: Int!) {
    accountGroup: getAccountGroupMaster(accountgroupid: $accountgroupid) {
      accountgroupid
      companyid
      companybranchid
      accountgroupname
      accountparentgroupid
    }
    subGroup: listaccountsubgroups(accountgroupid: $accountgroupsubid) {
      accountgroupid
      companyid
      companybranchid
      accountgroupname
      accountparentgroupid
    }
  }
`;
export const getPartyMasterSupplier = gql`
  query GetPartyDetails(
    $partyid: Int!
    $ObjectType1: String!
    $ObjectType2: String!
    $ObjectType3: String!
    $ObjectType4: String!
    $ObjectID: String!
    $accountgroupid: Int!
    $accountgroupsubid: Int!
  ) {
    partyMaster: getPartyMaster(partyid: $partyid) {
      partyid
      companyid
      companybranchid
      partytypecd
      partydisplayname
      partylegalname
      groupaccountid
      gstcategory
      placeofsupply
      entity
      email
      contactnumber
      whatsappnumber
      accountsid
      is_active
      msmetype
      deliveryconsigneename
      deliveryconsigneegstin
      statuscode
      statusmessage
      relatedpartygstdetails {
        partyid
        pannumber
        gstin
        partyaddressid
      }
      relatedpartycreditdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        creditperiodduration
        billingcurrency
        creditlimitcd
        creditlimitamount
        billwiseflag
        notes
      }
      relatedpartycontact {
        partyid
        contacttypename
        contactdesignationname
        contactorder
        email
        phonenumber
        whatsappnumber
      }
      relatedpartyimages {
        attachmentid
        partyid
        companyid
        enteredtimestamp
        expiredtimestamp
        type
        documentname
        imagename
        imageurl
      }
      lastupdatedby
      tdspercentage
      udhyamregno
      sameaddressflag
      comments
      tdssection
      __typename
    }
    partyBilling: getPartyAddressEntity(objecttype: $ObjectType1, objectid: $ObjectID) {
      id
      objecttype
      objectid
      line1
      city
      statecode
      statuscode
      statusmessage
      pincode
      countrycode
      district
      lastupdatedby
    }

    accountGroup: getAccountGroupMaster(accountgroupid: $accountgroupid) {
      accountgroupid
      companyid
      companybranchid
      accountgroupname
      accountparentgroupid
    }
    subGroup: listaccountsubgroups(accountgroupid: $accountgroupsubid) {
      accountgroupid
      companyid
      companybranchid
      accountgroupname
      accountparentgroupid
    }
    bankData: getBankDetails(objectid: $ObjectID, objecttype: $ObjectType3) {
      bankdetailsid
      companyid
      companybranchid
      objectid
      userid
      bankname
      bankaccountnumber
      ifsccode
      branch
      notes
      ledgeraccount
      bankaccounttype
      cash
      swiftcode
      upi
    }
    partyDelivery: getPartyAddressEntity(objecttype: $ObjectType2, objectid: $ObjectID) {
      id
      objecttype
      objectid
      line1
      city
      statecode
      statuscode
      statusmessage
      consigneename
      foreignstate
      foreigndistrict
      consigneegstin
      pincode
      countrycode
      district
      lastupdatedby
    }
    tds: getCompanyCodeTranslation(codetype: $ObjectType4) {
      id
      companyid
      codetype
      codevalue
      codetext
      codeorder
      uqc
      is_active
    }
  }
`;
export const getPartyAddressEway = gql`
  query GetPartyAddressEntity($objectid: String!, $objecttype1: String!, $objecttype2: String!) {
    partyBilling: getPartyAddressEntity(objectid: $objectid, objecttype: $objecttype1) {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      line1
      line2
      line3
      city
      statecode
      statuscode
      statusmessage
      foreignstate
      foreigndistrict
      pincode
      countrycode
      district
      lastupdatedby
      __typename
    }
    partyDelivery: getPartyAddressEntity(objectid: $objectid, objecttype: $objecttype2) {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      line1
      line2
      line3
      city
      statecode
      statuscode
      statusmessage
      foreignstate
      foreigndistrict
      consigneename
      consigneegstin
      pincode
      countrycode
      district
      lastupdatedby
      __typename
    }
  }
`;

export const getPartyAddressEinv = gql`
  query GetPartyAddressEntity($objectid: String!, $objecttype1: String!) {
    partyBilling: getPartyAddressEntity(objectid: $objectid, objecttype: $objecttype1) {
      id
      objecttype
      objectid
      enteredtimestamp
      expiredtimestamp
      line1
      line2
      line3
      city
      statecode
      statuscode
      statusmessage
      foreignstate
      foreigndistrict
      pincode
      countrycode
      district
      lastupdatedby
      __typename
    }
  }
`;
export const getPartyMasterCust = gql`
  query GetPartyDetails(
    $partyid: Int!
    $objecttype1: String!
    $objecttype2: String!
    $objectid: String!
    $accountgroupid: Int!
    $accountgroupsubid: Int!
  ) {
    partyMaster: getPartyMaster(partyid: $partyid) {
      partyid
      companyid
      companybranchid
      partytypecd
      enteredtimestamp
      partydisplayname
      partylegalname
      groupaccountid
      gstcategory
      placeofsupply
      entity
      email
      contactnumber
      whatsappnumber
      accountsid
      is_active
      msmetype
      deliveryconsigneename
      deliveryconsigneegstin
      statuscode
      statusmessage
      relatedpartygstdetails {
        partyid
        pannumber
        gstin
        partyaddressid
      }
      relatedpartycreditdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        creditperiodduration
        billingcurrency
        creditlimitcd
        creditlimitamount
        billwiseflag
        notes
      }
      relatedpartycontact {
        partyid
        contacttypename
        contactdesignationname
        contactorder
        email
        phonenumber
        whatsappnumber
        contactcountry
        whatsappcountry
      }
      relatedpartyimages {
        attachmentid
        partyid
        companyid
        enteredtimestamp
        expiredtimestamp
        type
        documentname
        imagename
        imageurl
      }
      lastupdatedby
      tdspercentage
      contactcountry
      whatsappcountry
      udhyamregno
      sameaddressflag
      comments
      tdssection
      __typename
    }
    partyBilling: getPartyAddressEntity(objecttype: $objecttype1, objectid: $objectid) {
      id
      objecttype
      objectid
      line1
      city
      statecode
      statuscode
      foreignstate
      foreigndistrict
      statusmessage
      pincode
      countrycode
      district
      lastupdatedby
    }
    partyDelivery: getPartyAddressEntity(objecttype: $objecttype2, objectid: $objectid) {
      id
      objecttype
      objectid
      line1
      city
      statecode
      statuscode
      statusmessage
      foreignstate
      foreigndistrict
      pincode
      consigneename
      consigneegstin
      countrycode
      district
      lastupdatedby
    }
    accountGroup: getAccountGroupMaster(accountgroupid: $accountgroupid) {
      accountgroupid
      companyid
      companybranchid
      accountgroupname
      accountparentgroupid
    }
    subGroup: listaccountsubgroups(accountgroupid: $accountgroupsubid) {
      accountgroupid
      companyid
      companybranchid
      accountgroupname
      accountparentgroupid
    }
  }
`;
export const listPurchaseMasterCustomWithOutRelated = /* GraphQL */ `
  query ListPurchaseMaster {
    listPurchaseMasterTestCustom {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      purchasegsttypecd
      supplierid
      entrydate
      vouchernumber
      supplierinvoicedate
      supplierinvoicenumber
      supplieraddressid
      paymenttypecd
      paidamount
      creditduration
      paymentaccountid
      comments
      tdsapplicableflag
      granttotalamount
      balancedueamount
      paymentclearedflag
      placeofsupply
      companystate
      ewaybillno
      validupto
      ewaybill_is_cancelled
      ewaybill_cancel_remarks
      cancel_rsn_code
      einvoiceenteredtimestamp
      ewaybillenteredtimestamp
    }
  }
`;
export const listPartyAndTransactionMastersCustomRec = /* GraphQL */ `
  query GetPartyAndTransactionData {
    listPartymasters: listPartymasters {
      partyid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      partytypecd
      partydisplayname
      groupaccountid
      gstcategory
      entity
      contactnumber
      whatsappnumber
      accountsid
      is_active
      msmetype
      deliveryconsigneename
      deliveryconsigneegstin
      statuscode
      statusmessage
    }
    listTransactionMaster: listTransactionMaster {
      transactionid
      companyid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      vouchernumber
      entrydate
      bankreferencenumber
    }
  }
`;
export const getTransactionMasterManualJournal = /* GraphQL */ `
  query GetTransactionMaster($transactionid: Int!) {
    getTransactionMaster(transactionid: $transactionid) {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      vouchernumber
      entrydate
      bankreferencenumber
      comments
      cancelflag
      isvouchereditable
      serialnumber
      relatedtransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        accountid
        creditamount
        debitamount
        comments
        entryordernumber
        transactionbalance
        openingbalance
      }
      relatedtransactionattachment {
        transactionid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        documentname
        statuscode
        statusmessage
        type
        __typename
      }
    }
  }
`;
export const listlatestInvoiceCustom = /* GraphQL */ `
  query ListlatestInvoice {
    listlatestInvoice {
      invoiceid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      invoicetypecd
      partyid
      paymentaccountid
      invoicedate
      invoicenumber
      customerordernumber
      customerorderdate
      invoiceamount
      paymenttype
      creditduration
      invoicebillingaddressid
      invoicedeliveryaddressid
      invoicetaxabletypecd
      receipturl
      invoicelinetypecd
      invoicecurrencycd
      exchangerate
      comments
      receivedamount
      adjustmentamount
      placeofsupply
      balancedueamount
      reversechargeflag
      tcsapplicableflag
    }
  }
`;
export const listlatestPurchaseCustom = /* GraphQL */ `
  query ListlatestPurchase {
    listlatestPurchase {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      purchasegsttypecd
      supplierid
      entrydate
      vouchernumber
      supplierinvoicedate
      supplierinvoicenumber
      supplieraddressid
      paymenttypecd
      paidamount
      creditduration
      paymentaccountid
      comments
      tdsapplicableflag
      granttotalamount
      balancedueamount
      paymentclearedflag
      placeofsupply
      companystate
    }
  }
`;
export const listTransactionManualJournalWithVoucher = /* GraphQL */ `
  query ListTransactionManualJournal {
    listTransactionManualJournal {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      vouchernumber
      entrydate
      bankreferencenumber
      comments
    }
  }
`;
export const getAccountMasterName = `
  query GetAccountMaster($accountsid: Int!) {
    getAccountMaster(accountsid: $accountsid) {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
    }
  }
`;
export const listCashAccountsCustom = gql`
  query ListCashAccounts {
    listCashAccounts {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accountgroupname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag
      __typename
    }
    listBankAccounts {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accountgroupname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag

      __typename
    }
  }
`;
export const listBankAccountsCustom = /* GraphQL */ `
  query ListBankAccounts {
    listBankAccounts {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accountgroupname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accounttypeflag

      __typename
    }
  }
`;
export const listAccountMasterCustom = /* GraphQL */ `
  query ListAccountMaster {
    listAccountMaster {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      relatedaccountbalance {
        accountbalance
        __typename
      }
      __typename
    }
  }
`;
export const listOutstandingInvoiceMasterCustom = /* GraphQL */ `
  query ListOutstandingInvoiceMaster {
    listOutstandingInvoiceMaster {
      invoiceid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      invoicetypecd
      partyid
      paymentaccountid
      invoicedate
      invoicenumber
      customerordernumber
      customerorderdate
      invoiceamount
      paymenttype
      creditduration
      invoicebillingaddressid
      invoicedeliveryaddressid
      invoicetaxabletypecd
      receipturl
      invoicelinetypecd
      invoicecurrencycd
      exchangerate
      comments
      receivedamount
      adjustmentamount
      placeofsupply
      balancedueamount
      reversechargeflag
      tcsapplicableflag
      lastupdatedby
      statuscode
      statusmessage
      cancelflag
      consigneename
      consigneegstin
      companystate
      cancelremark
      deleteremark
      roundoffamount
      discounttype
      discountvalue
      serialnumber
      currencycode
      currencyrate
      partydisplayname
      partyaccountid
      __typename
    }
  }
`;
export const listOutstandingPurchaseMasterCustom = /* GraphQL */ `
  query ListOutstandingPurchaseMaster {
    listOutstandingPurchaseMaster {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      purchasegsttypecd
      supplierid
      entrydate
      vouchernumber
      supplierinvoicedate
      supplierinvoicenumber
      supplieraddressid
      paymenttypecd
      paidamount
      creditduration
      paymentaccountid
      comments
      tdsapplicableflag
      granttotalamount
      balancedueamount
      paymentclearedflag
      placeofsupply
      companystate
      lastupdatedby
      cancelflag
      roundoffamount
      discounttype
      discountvalue
      adjustmentamount
      statuscode
      statusmessage
      serialnumber
      currencycode
      currencyrate
      partydisplayname
      partylegalname
      partyaccountid
      __typename
    }
  }
`;
export const listPurchaseMasterTestCustom = /* GraphQL */ `
  query ListPurchaseMasterTest(
    $rowfrom: Int!
    $limitno: Int!
    $columnname: String
    $ordertype: String
    $searchmode: Int
    $searcharray: AWSJSON
  ) {
    listPurchaseMasterTest(
      rowfrom: $rowfrom
      limitno: $limitno
      columnname: $columnname
      ordertype: $ordertype
      searchmode: $searchmode
      searcharray: $searcharray
    ) {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      purchasegsttypecd
      supplierid
      entrydate
      vouchernumber
      ewaybillpdf
      supplierinvoicedate
      supplierinvoicenumber
      supplieraddressid
      paymenttypecd
      paidamount
      creditduration
      paymentaccountid
      comments
      tdsapplicableflag
      granttotalamount
      balancedueamount
      paymentclearedflag
      placeofsupply
      companystate
      lastupdatedby
      cancelflag
      roundoffamount
      discounttype
      discountvalue
      adjustmentamount
      statuscode
      statusmessage
      serialnumber
      currencycode
      ewaybillstatus
      currencyrate
      partydisplayname
      partylegalname
      partyaccountid
      reversechargeflag
      overduedays
      paymentstatus
      partyregistrationtype
      purchaseinvoicepdf
      ewaybillno
      validupto
      ewaybill_is_cancelled
      ewaybill_cancel_remarks
      cancel_rsn_code
      einvoiceenteredtimestamp
      ewaybillenteredtimestamp
      duedatetimestamp
      goods_exist
      __typename
      relatedpartyaddressdetails {
        id
        objecttype
        objectid
        enteredtimestamp
        expiredtimestamp
        line1
        line2
        line3
        city
        statecode
        statuscode
        statusmessage
        pincode
        countrycode
        district
        lastupdatedby
        __typename
      }
    }
  }
`;
export const getInvoiceMasterEwayBillCustom = /* GraphQL */ `
  query GetInvoiceMaster($invoiceid: Int!) {
    getInvoiceMaster(invoiceid: $invoiceid) {
      invoiceid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      invoicetypecd
      partyid
      paymentaccountid
      invoicedate
      invoicenumber
      invoiceamount
      invoicebillingaddressid
      invoicedeliveryaddressid
      invoicetaxabletypecd
      receipturl
      invoicelinetypecd
      invoicecurrencycd
      exchangerate
      comments
      receivedamount
      adjustmentamount
      placeofsupply

      relatedinvoicetcsdetails {
        invoiceid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tcsapplicablecd
        totaltaxableamount
        ineligibletcflag
        reversechargeflag
        gstcesstotal
        tcsamount
        adjustmentamount
        tcssection
        lastupdatedby
        statuscode
        statusmessage
        tcspercentage
        tcsmanual
        __typename
      }
      relatedinvoicelineitems {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        lineitemnumber
        invoicelineitemtype
        itemid
        quantity
        unittypecd
        itemrate
        itemamount
        itemdiscount
        netamount
        hsnsaccode
        taxability
        manualdiscount
        manualcess
        lastupdatedby
        statuscode
        statusmessage
        pricetype
        lotid
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gsttypecd
        gstamount
        cessamount
        unit
        uqc
        salesaccountname
        salesaccountid
        itemname
        itemcode
        itemtype
        __typename
      }
      relatedinvoicelinenonitems {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        invoicelineitemtype
        incomeaccountid
        hsnsaccode
        taxability
        itemdescription
        taxableamount
        netamount

        lastupdatedby
        statuscode
        statusmessage
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gsttypecd
        gstamount
        cessamount
        incomeaccountname
        __typename
      }
      relatedinvoiceaddressdetails {
        id
        objecttype
        objectid
        enteredtimestamp
        expiredtimestamp
        line1
        line2
        line3
        city
        statecode
        statuscode
        statusmessage
        pincode
        countrycode
        district
        lastupdatedby
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      cancelflag
      consigneename
      consigneegstin
      companystate
      cancelremark
      deleteremark
      roundoffamount
      discounttype
      discountvalue
      serialnumber
      currencycode
      currencyrate
      partydisplayname
      partylegalname
      partyaccountid
      paymentstatus
      partygstcategory
      ackno
      ackdt
      irn
      signedqrcode
      partyemail
      invoicepdf
      partygstin
      partytypecd
      __typename
    }
  }
`;
export const getPurchaseMasteEwayBillrCustom = /* GraphQL */ `
  query GetPurchaseMaster($purchaseid: Int!) {
    getPurchaseMaster(purchaseid: $purchaseid) {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      purchasegsttypecd
      supplierid
      entrydate
      vouchernumber
      supplierinvoicedate
      supplierinvoicenumber
      supplieraddressid
      paymenttypecd
      paidamount
      creditduration
      paymentaccountid
      comments
      tdsapplicableflag
      granttotalamount
      balancedueamount
      paymentclearedflag
      placeofsupply
      companystate
      relatedpurchasetdsdetails {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tdsapplicablecd
        totaltaxableamount
        ineligibletcflag
        reversechargeflag
        gstcesstotal
        tdsamount
        adjustmentamount
        tdssection
        tdspercentage
        tdsmanual
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpurchasetcsdetails {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tcsapplicablecd
        totaltaxableamount
        ineligibletcflag
        reversechargeflag
        gstcesstotal
        tcsamount
        adjustmentamount
        tcssection
        lastupdatedby
        statuscode
        statusmessage
        tcspercentage
        tcsmanual
        __typename
      }
      relatedpurchaselineitems {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        itemnumber
        itemid
        purchaseaccountid
        hsncode
        itemquantity
        unittypecd
        itemrate
        itemamount
        itemdiscount
        netamount
        manualdiscount
        manualcess

        lastupdatedby
        statuscode
        statusmessage
        taxability
        pricetype
        lotid
        hsnid
        hsncodetype
        hsndescription
        gstrate
        gstamount
        cessamount
        unit
        uqc
        purchaseaccountname
        itemname
        itemcode
        itemtype
        __typename
      }
      relatedpurchaselinenonitems {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        purchaselineitemtype
        purchaseaccountid
        hsnsaccode
        itemdescription
        taxableamount
        netamount

        lastupdatedby
        statuscode
        statusmessage
        taxability
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gstamount
        cessamount
        purchaseaccountname
        __typename
      }
      relatedpurchaseaddressdetails {
        id
        objecttype
        objectid
        enteredtimestamp
        expiredtimestamp
        line1
        line2
        line3
        city
        statecode
        statuscode
        statusmessage
        pincode
        countrycode
        district
        lastupdatedby
        __typename
      }
      lastupdatedby
      cancelflag
      roundoffamount
      discounttype
      discountvalue
      adjustmentamount
      statuscode
      statusmessage
      serialnumber
      currencycode
      currencyrate
      partydisplayname
      partylegalname
      partyaccountid
      reversechargeflag
      partygstcategory
      overduedays
      partygstin
      partytypecd
      paymentstatus
      partyregistrationtype
      purchaseinvoicepdf
      __typename
    }
  }
`;
export const getInvoiceMasterCustom = /* GraphQL */ `
  query GetInvoiceMaster($invoiceid: Int!) {
    getInvoiceMaster(invoiceid: $invoiceid) {
      invoiceid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      invoicetypecd
      partyid
      paymentaccountid
      invoicedate
      invoicenumber
      customerordernumber
      customerorderdate
      invoiceamount
      is_cancelled
      paymenttype
      creditduration
      invoicebillingaddressid
      invoicedeliveryaddressid
      invoicetaxabletypecd
      receipturl
      invoicelinetypecd
      invoicecurrencycd
      exchangerate
      comments
      receivedamount
      adjustmentamount
      placeofsupply
      balancedueamount
      reversechargeflag
      tcsapplicableflag
      bankaccountid
      bankamount
      accountname
      isvouchereditable
      serialflag
      relatedinvoicetcsdetails {
        invoiceid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tcsapplicablecd
        totaltaxableamount
        ineligibletcflag
        reversechargeflag
        gstcesstotal
        tcsamount
        adjustmentamount
        tcssection
        lastupdatedby
        statuscode
        statusmessage
        tcspercentage
        tcsmanual
        __typename
      }
      relatedinvoicelineitems {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        lineitemnumber
        invoicelineitemtype
        itemid
        quantity
        unittypecd
        itemrate
        itemamount
        itemdiscount
        netamount
        hsnsaccode
        taxability
        manualdiscount
        manualcess
        cesstype
        cessrate
        lastupdatedby
        statuscode
        statusmessage
        pricetype
        lotid
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gsttypecd
        gstamount
        cessamount
        unit
        uqc
        salesaccountname
        salesaccountid
        itemname
        itemcode
        itemtype
        manualgst
        discounttype
        discountrate
        __typename
      }
      relatedinvoicelinenonitems {
        invoiceid
        invoiceitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        invoicelineitemtype
        incomeaccountid
        hsnsaccode
        taxability
        itemdescription
        taxableamount
        netamount
        manualgst
        manualcess
        cesstype
        cessrate
        lastupdatedby
        statuscode
        statusmessage
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gsttypecd
        gstamount
        cessamount
        incomeaccountname
        __typename
      }
      relatedinvoiceattachment {
        invoiceid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        statuscode
        statusmessage
        documentname
        type
        __typename
      }
      relatedinvoicedispatch {
        invoiceid
        dispatchid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transportationcd
        vehiclenumber
        dispatchdate
        ewaybillnumber
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedinvoiceposdetails {
        posid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        partyposid
        lastupdatedby
        relatedposparty {
          pospartyid
          companyid
          partyname
          partycontactnumberid
          lastupdatedby
          enteredtimestamp
          expiredtimestamp
          relatedphonecontacts {
            id
            objecttype
            objectid
            enteredtimestamp
            expiredtimestamp
            countrycode
            phonenumber
            verifieddatetime
            promotionssignup
            smsallowed
            callallowed
            whatsappallowed
            lastupdatedby
            statuscode
            statusmessage
            __typename
          }
          __typename
        }
        statuscode
        statusmessage

        __typename
      }

      relatedinvoicetransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        vouchernumber
        entrydate
        bankreferencenumber
        comments

        lastupdatedby
        statuscode
        statusmessage
        cancelflag
        cancelremark
        serialnumber
        pdflink
        __typename
      }
      relatedinvoiceaddressdetails {
        id
        objecttype
        objectid
        enteredtimestamp
        expiredtimestamp
        line1
        line2
        line3
        city
        statecode
        statuscode
        statusmessage
        pincode
        countrycode
        district
        lastupdatedby
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      cancelflag
      consigneename
      consigneegstin
      companystate
      cancelremark
      deleteremark
      roundoffamount
      discounttype
      discountvalue
      serialnumber
      currencycode
      currencyrate
      partydisplayname
      partylegalname
      partyaccountid
      paymentstatus
      partygstcategory
      ackno
      ackdt
      irn
      signedqrcode
      partyemail
      invoicepdf
      partygstin
      partyisactive
      partytypecd
      __typename
    }
  }
`;
export const getPurchaseMasterCustom = /* GraphQL */ `
  query GetPurchaseMaster($purchaseid: Int!) {
    getPurchaseMaster(purchaseid: $purchaseid) {
      purchaseid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      purchasegsttypecd
      supplierid
      entrydate
      vouchernumber
      supplierinvoicedate
      supplierinvoicenumber
      supplieraddressid
      paymenttypecd
      paidamount
      creditduration
      paymentaccountid
      comments
      tdsapplicableflag
      granttotalamount
      balancedueamount
      paymentclearedflag
      placeofsupply
      companystate
      accountname
      isvouchereditable
      itcflag
      relatedpurchasetdsdetails {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tdsapplicablecd
        totaltaxableamount
        ineligibletcflag
        reversechargeflag
        gstcesstotal
        tdsamount
        adjustmentamount
        tdssection
        tdspercentage
        tdsmanual
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpurchasetcsdetails {
        purchaseid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        tcsapplicablecd
        totaltaxableamount
        ineligibletcflag
        reversechargeflag
        gstcesstotal
        tcsamount
        adjustmentamount
        tcssection
        lastupdatedby
        statuscode
        statusmessage
        tcspercentage
        tcsmanual
        __typename
      }
      relatedpurchaselineitems {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        itemnumber
        itemid
        purchaseaccountid
        hsncode
        itemquantity
        unittypecd
        itemrate
        itemamount
        itemdiscount
        netamount
        manualdiscount
        manualcess
        cesstype
        cessrate
        manualgst
        lastupdatedby
        statuscode
        statusmessage
        taxability
        pricetype
        lotid
        hsnid
        hsncodetype
        hsndescription
        gstrate
        gstamount
        cessamount
        unit
        uqc
        purchaseaccountname
        itemname
        itemcode
        itemtype
        discounttype
        discountrate
        __typename
      }
      relatedpurchaselinenonitems {
        purchaseid
        purchaseitemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        purchaselineitemtype
        purchaseaccountid
        hsnsaccode
        itemdescription
        taxableamount
        netamount
        manualgst
        manualcess
        cesstype
        cessrate
        lastupdatedby
        statuscode
        statusmessage
        taxability
        hsnsacid
        hsncodetype
        hsncodevalue
        hsndescription
        gstrate
        gstamount
        cessamount
        purchaseaccountname
        __typename
      }

      relatedpurchaseattachment {
        purchaseid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        statuscode
        statusmessage
        documentname
        type
        __typename
      }
      relatedpurchasetransactiondetails {
        transactionid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        transactiontypecd
        vouchernumber
        entrydate
        bankreferencenumber
        comments

        lastupdatedby
        statuscode
        statusmessage
        cancelflag
        cancelremark
        serialnumber
        pdflink
        __typename
      }

      lastupdatedby
      cancelflag
      roundoffamount
      discounttype
      discountvalue
      adjustmentamount
      statuscode
      statusmessage
      serialnumber
      currencycode
      currencyrate
      partydisplayname
      partylegalname
      partyaccountid
      reversechargeflag
      partygstcategory
      overduedays
      partygstin
      partyisactive
      partytypecd
      paymentstatus
      partyregistrationtype
      purchaseinvoicepdf
      consigneename
      consigneegstin
      __typename
    }
  }
`;

export const listPartymastersCustom = /* GraphQL */ `
  query ListPartymasters {
    listPartymasters {
      partyid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      partytypecd
      partydisplayname
      partylegalname
      groupaccountid
      gstcategory
      placeofsupply
      entity
      email
      contactnumber
      whatsappnumber
      accountsid
      is_active
      msmetype
      deliveryconsigneename
      deliveryconsigneegstin
      statuscode
      statusmessage
      relatedpartygstdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        pannumber
        gstin
        partyaddressid
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycreditdetails {
        partyid
        enteredtimestamp
        expiredtimestamp
        creditperiodduration
        billingcurrency
        creditlimitcd
        creditlimitamount
        billwiseflag
        notes
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }
      relatedpartycontact {
        partyid
        enteredtimestamp
        expiredtimestamp
        contacttypename
        contactdesignationname
        contactorder
        email
        phonenumber
        whatsappnumber
        lastupdatedby
        statuscode
        statusmessage
        __typename
      }

      lastupdatedby
      tdspercentage
      udhyamregno
      sameaddressflag
      comments
      tdssection
      __typename
    }
  }
`;
export const getItemmasterAmountDetails = /* GraphQL */ `
  query GetItemmasterAmountDetails($itemid: Int!) {
    getItemmaster(itemid: $itemid) {
      itemid
      relateditemamountdetails {
        id
        itemid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        amount
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstcompensationvalue
        gstrate
        statuscode
        statusmessage
        lastupdatedby
        discounttype
        discountvalue
        invoicetype
        pricetype
        pricetypeid
        isactive
        isdefault
        __typename
      }
    }
  }
`;

export const getTransactionMasterV2 = /* GraphQL */ `
  query GetTransactionMaster($transactionid: Int!) {
    getTransactionMaster(transactionid: $transactionid) {
      transactionid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      transactiontypecd
      vouchernumber
      entrydate
      bankreferencenumber
      comments
      relatedtransactionattachment {
        transactionid
        attachmentid
        companyid
        companybranchid
        enteredtimestamp
        expiredtimestamp
        attachmentname
        attachmenturl
        lastupdatedby
        documentname
        statuscode
        statusmessage
        type
        __typename
      }
      lastupdatedby
      statuscode
      statusmessage
      cancelflag
      cancelremark
      serialnumber
      pdflink
      towards
      __typename
    }
  }
`;
export const getLedgerGSTData = /* GraphQL */ `
  query GetAccountMaster($accountsid: Int!) {
    getAccountMaster(accountsid: $accountsid) {
      accountsid
      accountname
      accountgroupid
      accounttypecd
      path
      relatedaccountgstdetails {
        accountid
        companyid
        enteredtimestamp
        expiredtimestamp
        effectivedate
        expireddate
        hsnid
        gstcompensationtype
        gstrate
        cessamount
        lastupdatedby
        statuscode
        statusmessage
        hsnsaccode
        codetype
        description
        taxability
        __typename
      }
      __typename
    }
  }
`;
